module.exports = __webpack_public_path__ + "static/media/fbe-engraving-pattern-gold10.609e6faf.svg";